// src/AllCustomers.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { database, ref, onValue } from "./firebase"; 
import { products } from "./salesmanHelpers"; // ✅ needed to map products
import "./BillingSystem.css";
import BossNavigation from "./BossNavigation";

export default function AllCustomers() {
  const [customers, setCustomers] = useState([]);
  const [salesmanPhone, setSalesmanPhone] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!salesmanPhone) return;

    const invoicesRef = ref(database, `salesmanInvoices/${salesmanPhone}`);

    const unsubscribe = onValue(invoicesRef, (snapshot) => {
      if (!snapshot.exists()) {
        setCustomers([]);
        return;
      }

      const invoices = Object.values(snapshot.val());
      const customerMap = {};

      invoices.forEach((inv) => {
        const name = inv.customerName || "Unknown";
        const cphone = inv.customerPhone || "N/A";
        const route = inv.route || "-";

        if (!customerMap[cphone]) {
          customerMap[cphone] = {
            name,
            phone: cphone,
            route,
            totals: Array(products.length).fill(0),
            schemes: Array(products.length).fill(0),
          };
        }

        inv.items?.forEach((item) => {
          const idx = products.indexOf(item.product);
          if (idx !== -1) {
            customerMap[cphone].totals[idx] += item.quantity || 0;
            customerMap[cphone].schemes[idx] += item.scheme || 0;
          }
        });
      });

      // Convert to array and calculate totals
      const customerList = Object.values(customerMap).map((c) => {
        const totalUnits = c.totals.reduce((a, b) => a + b, 0);
        const totalSchemes = c.schemes.reduce((a, b) => a + b, 0);
        return { ...c, totalUnits, totalSchemes };
      });

      // Sort by cartons
      customerList.sort((a, b) => b.totalUnits - a.totalUnits);

      setCustomers(customerList);
    });

    return () => unsubscribe();
  }, [salesmanPhone]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>All Customer Details</h2>
       <BossNavigation />

      {/* Salesman Phone Input */}
      <input
        type="text"
        placeholder="Enter Salesman Phone Number"
        value={salesmanPhone}
        onChange={(e) => setSalesmanPhone(e.target.value)}
        style={{
          marginBottom: "10px",
          padding: "8px",
          width: "250px",
        }}
      />

      {customers.length > 0 ? (
        <>
          <button onClick={handlePrint} style={{ marginBottom: "10px" }}>
            🖨 Print
          </button>

          <table
            border="1"
            cellPadding="5"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Route</th>
                <th>Total Units (Cartons)</th>
                <th>Total Schemes</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{c.name}</td>
                  <td>{c.phone}</td>
                  <td>{c.route}</td>
                  <td>{c.totalUnits}</td>
                  <td>{c.totalSchemes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>No customers found for this salesman.</p>
      )}

      <button onClick={() => navigate(-1)} style={{ marginTop: "10px" }}>
        ⬅ Back
      </button>
    </div>
  );
}
